/**
 * cart-line-sync.js
 *
 * Zentrale Stelle, über die ALLE optionalen Zusatzauswahlen einer
 * Warenkorb-Zeile (Prämie, Studentennachweis, Abo-Startmonat, künftige
 * weitere) gemeinsam gelesen und gespeichert werden.
 *
 * Grund: Shopifys /cart/change.js kann keine Properties an einer
 * bestehenden Position ändern (nur die Menge) – deshalb muss bei jeder
 * Auswahl die Position entfernt und mit ALLEN aktuellen Werten neu
 * hinzugefügt werden. Wenn jedes Feature das unabhängig täte, würde
 * jede Aktualisierung die Werte der anderen Features überschreiben
 * (das ist der Bug den wir bei Prämie/Studentennachweis hatten).
 *
 * Nutzung durch andere Scripts:
 *   window.cartLineSync.aktualisieren(zeile);
 *   // zeile = das <tr class="cart-item"> Element
 *
 * Jedes Feature-Script muss nur sein eigenes Lese-Modul unten ergänzen
 * (readPraemienProperties, readStudentProperty, readAboStartProperty)
 * – die eigentliche Synchronisierung passiert zentral hier.
 */

(function () {
  function readPraemienProperties(zeile) {
    const properties = {};
    const container = zeile.querySelector('.cart-item__praemien-auswahl');
    if (!container) return properties;

    const verzichtCheckbox = container.querySelector('.cart-item__praemien-verzicht-checkbox');
    if (verzichtCheckbox && verzichtCheckbox.checked) {
      properties['_Pramie_Verzicht'] = 'Ja';
      return properties;
    }

    container.querySelectorAll('.cart-item__praemien-select').forEach(function (select) {
      const index = select.getAttribute('data-praemien-index');
      const anzahl = parseInt(container.getAttribute('data-anzahl-pramien'), 10) || 1;
      if (select.value) {
        const label = anzahl === 1 ? 'Prämie' : 'Prämie ' + index;
        properties[label] = select.value;
      }
    });

    return properties;
  }

  function readStudentProperty(zeile) {
    const properties = {};
    const checkbox = zeile.querySelector('.cart-item__studentennachweis-checkbox');
    if (checkbox && checkbox.checked) {
      properties['_Studentennachweis_Bestaetigt'] = 'Ja';
    }
    return properties;
  }

  function readAboStartProperty(zeile) {
    const properties = {};
    const select = zeile.querySelector('.cart-item__abo-start-select');
    if (select && select.value) {
      properties['Abo-Start'] = select.value;
    }
    return properties;
  }

  function allePropertiesDerZeileLesen(zeile) {
    return Object.assign(
      {},
      readPraemienProperties(zeile),
      readStudentProperty(zeile),
      readAboStartProperty(zeile)
    );
  }

  const REIHENFOLGE_STORAGE_KEY = 'cartLineSyncReihenfolge';

  /**
   * Merkt sich die aktuelle Reihenfolge der Warenkorb-Zeilen (anhand der
   * Varianten-ID), damit sie nach dem Neuladen wiederhergestellt werden
   * kann. Ohne das würde die Position durch "entfernen + neu hinzufügen"
   * technisch ans Ende des Warenkorbs springen, da Shopify keine andere
   * Möglichkeit bietet, Properties nachträglich zu ändern.
   */
  function reihenfolgeMerken() {
    const variantIds = Array.from(document.querySelectorAll('tr.cart-item'))
      .map(function (row) { return row.getAttribute('data-line-variant-id'); })
      .filter(Boolean);
    sessionStorage.setItem(REIHENFOLGE_STORAGE_KEY, JSON.stringify(variantIds));
  }

  /**
   * Stellt die gemerkte Reihenfolge nach dem Neuladen wieder her, indem
   * die Zeilen im DOM entsprechend neu sortiert werden. Rein visuell –
   * die tatsächliche Reihenfolge im Shopify-Warenkorb selbst bleibt
   * unverändert, das sieht der Kunde aber nicht.
   */
  function reihenfolgeWiederherstellen() {
    const gespeichert = sessionStorage.getItem(REIHENFOLGE_STORAGE_KEY);
    if (!gespeichert) return;
    sessionStorage.removeItem(REIHENFOLGE_STORAGE_KEY);

    let variantIds;
    try {
      variantIds = JSON.parse(gespeichert);
    } catch (e) {
      return;
    }

    const tbody = document.querySelector('table.cart-items tbody');
    if (!tbody) return;

    const zeilen = Array.from(tbody.querySelectorAll('tr.cart-item'));
    variantIds.forEach(function (variantId) {
      const zeile = zeilen.find(function (row) {
        return row.getAttribute('data-line-variant-id') === variantId;
      });
      if (zeile) tbody.appendChild(zeile);
    });
  }

  /**
   * Entfernt die aktuelle Position und fügt sie mit ALLEN aktuell
   * gültigen Zusatz-Eigenschaften der Zeile neu hinzu.
   */
  async function aktualisieren(zeile) {
    const variantId = zeile.getAttribute('data-line-variant-id');
    const quantity = parseInt(zeile.getAttribute('data-line-quantity'), 10) || 1;
    const lineKey = zeile.getAttribute('data-line-key');

    if (!variantId || !lineKey) {
      console.error('cart-line-sync: variant-id oder line-key fehlt an der Zeile.', zeile);
      return;
    }

    const properties = allePropertiesDerZeileLesen(zeile);
    reihenfolgeMerken();

    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: 0 }),
      });

      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity,
          properties: properties,
        }),
      });

      window.location.reload();
    } catch (error) {
      console.error('cart-line-sync: Aktualisieren fehlgeschlagen:', error);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reihenfolgeWiederherstellen);
  } else {
    reihenfolgeWiederherstellen();
  }

  window.cartLineSync = {
    aktualisieren: aktualisieren,
    allePropertiesDerZeileLesen: allePropertiesDerZeileLesen,
  };
})();
